import DisplayedTimeFormat from '../DisplayedTimeFormat/DisplayedTimeFormat.vue';

export default {
  name: 'TimePeriodDisplay',
  components: {
    DisplayedTimeFormat,
  },
  props: {
    horizon: {
      default: false,
      type: Boolean,
    },
    periods: {
      default: () => ([]),
      type: Array,
    },
    title: {
      default: '',
      type: String,
    },
  },
  computed: {
    displayedPeriod() {
      return this.periods?.[0] || {};
    },
    dropdownListItems() {
      const arr = [...this.periods];
      arr.shift();

      return arr || [];
    },
    showDropdown() {
      return this.periods?.length > 1;
    },
  },
};
